module.exports = __webpack_public_path__ + "static/media/config_icon_header.dd2b5952.svg";